/* eslint-disable camelcase */
import apron from '../../assets/images/your-design-here/apron.png'
import backpack from '../../assets/images/your-design-here/backpack.png'
import badge from '../../assets/images/your-design-here/badge.png'
import bag from '../../assets/images/your-design-here/bag.png'
import bandana from '../../assets/images/your-design-here/bandana.png'
import basic_hoodie from '../../assets/images/your-design-here/basic_hoodie.png'
import basketball_uniform from '../../assets/images/your-design-here/basketball_uniform.png'
import beanie from '../../assets/images/your-design-here/beanie.png'
import beer_mug from '../../assets/images/your-design-here/beer_mug.png'
import bib from '../../assets/images/your-design-here/bib.png'
import blackberry_z10_case from '../../assets/images/your-design-here/blackberry_z10_case.png'
import bodysuit from '../../assets/images/your-design-here/bodysuit.png'
import bottle_sticker from '../../assets/images/your-design-here/bottle_sticker.png'
import buff from '../../assets/images/your-design-here/buff.png'
import business_card from '../../assets/images/your-design-here/business_card.png'
import cake from '../../assets/images/your-design-here/cake.png'
import calendar_a2 from '../../assets/images/your-design-here/calendar_a2.png'
import calendar_a3 from '../../assets/images/your-design-here/calendar_a3.png'
import calendar_single_a2 from '../../assets/images/your-design-here/calendar_single_a2.png'
import can from '../../assets/images/your-design-here/can.png'
import candle from '../../assets/images/your-design-here/candle.png'
import canvas20x30 from '../../assets/images/your-design-here/canvas20x30.png'
import canvas30x30 from '../../assets/images/your-design-here/canvas30x30.png'
import canvas30x40 from '../../assets/images/your-design-here/canvas30x40.png'
import canvas30x60 from '../../assets/images/your-design-here/canvas30x60.png'
import canvas40x55 from '../../assets/images/your-design-here/canvas40x55.png'
import canvas50x50 from '../../assets/images/your-design-here/canvas50x50.png'
import canvas50x75 from '../../assets/images/your-design-here/canvas50x75.png'
import canvas60x90 from '../../assets/images/your-design-here/canvas60x90.png'
import cap_trucker from '../../assets/images/your-design-here/cap_trucker.png'
import cardboard_tag from '../../assets/images/your-design-here/cardboard_tag.png'
import cardholder from '../../assets/images/your-design-here/cardholder.png'
import chocolate from '../../assets/images/your-design-here/chocolate.png'
import chocolate_set_shell from '../../assets/images/your-design-here/chocolate_set_shell.png'
import chocolate_set_souffle from '../../assets/images/your-design-here/chocolate_set_souffle.png'
import chocolate_set4 from '../../assets/images/your-design-here/chocolate_set4.png'
import chocolate_set12 from '../../assets/images/your-design-here/chocolate_set12.png'
import chocolate_set16 from '../../assets/images/your-design-here/chocolate_set16.png'
import chocolate35x35 from '../../assets/images/your-design-here/chocolate35x35.png'
import christmas_ball from '../../assets/images/your-design-here/christmas_ball.png'
import christmas_tree_toy from '../../assets/images/your-design-here/christmas_tree_toy.png'
import city_backpack from '../../assets/images/your-design-here/city_backpack.png'
import classic_polo_shirt from '../../assets/images/your-design-here/classic_polo_shirt.png'
import classic_tee from '../../assets/images/your-design-here/classic_tee.png'
import classic_woman_polo from '../../assets/images/your-design-here/classic_woman_polo.png'
import classic_woman_tee from '../../assets/images/your-design-here/classic_woman_tee.png'
import colored_handle_mug from '../../assets/images/your-design-here/colored_handle_mug.png'
import colored_hood_and_sleeves_hoodie from '../../assets/images/your-design-here/colored_hood_and_sleeves_hoodie.png'
import colored_inside_mug from '../../assets/images/your-design-here/colored_inside_mug.png'
import colored_pocket_hoodie from '../../assets/images/your-design-here/colored_pocket_hoodie.png'
import cotton_backpack from '../../assets/images/your-design-here/cotton_backpack.png'
import crop_tee from '../../assets/images/your-design-here/crop_tee.png'
import cube from '../../assets/images/your-design-here/cube.png'
import cutting_board from '../../assets/images/your-design-here/cutting_board.png'
import cycling_shorts from '../../assets/images/your-design-here/cycling_shorts.png'
import dog_tee from '../../assets/images/your-design-here/dog_tee.png'
import earflap_hat from '../../assets/images/your-design-here/earflap_hat.png'
import euro_business_card from '../../assets/images/your-design-here/euro_business_card.png'
import flag22x15 from '../../assets/images/your-design-here/flag22x15.png'
import flag135x90 from '../../assets/images/your-design-here/flag135x90.png'
import flag150x100 from '../../assets/images/your-design-here/flag150x100.png'
import flash_driver from '../../assets/images/your-design-here/flash_driver.png'
import football_uniform from '../../assets/images/your-design-here/football_uniform.png'
import free_form_sticker from '../../assets/images/your-design-here/free_form_sticker.png'
import full_print_apron from '../../assets/images/your-design-here/full_print_apron.png'
import full_print_backpack from '../../assets/images/your-design-here/full_print_backpack.png'
import full_print_bag from '../../assets/images/your-design-here/full_print_bag.png'
import full_print_beanie from '../../assets/images/your-design-here/full_print_beanie.png'
import full_print_boy_tee from '../../assets/images/your-design-here/full_print_boy_tee.png'
import full_print_cosmetic_bag from '../../assets/images/your-design-here/full_print_cosmetic_bag.png'
import full_print_gloves from '../../assets/images/your-design-here/full_print_gloves.png'
import full_print_girl_tee from '../../assets/images/your-design-here/full_print_girl_tee.png'
import full_print_hoodie from '../../assets/images/your-design-here/full_print_hoodie.png'
import full_print_kids_sweatshirt from '../../assets/images/your-design-here/full_print_kids_sweatshirt.png'
import full_print_man_polo from '../../assets/images/your-design-here/full_print_man_polo.png'
import full_print_mittens from '../../assets/images/your-design-here/full_print_mittens.png'
import full_print_mug from '../../assets/images/your-design-here/full_print_mug.png'
import full_print_neck_pillow from '../../assets/images/your-design-here/full_print_neck_pillow.png'
import full_print_pencil_case from '../../assets/images/your-design-here/full_print_pencil_case.png'
import full_print_pencil_skirt from '../../assets/images/your-design-here/full_print_pencil_skirt.png'
import full_print_skirt from '../../assets/images/your-design-here/full_print_skirt.png'
import full_print_sport_tee from '../../assets/images/your-design-here/full_print_sport_tee.png'
import full_print_summer_dress from '../../assets/images/your-design-here/full_print_summer_dress.png'
import full_print_sweatshirt from '../../assets/images/your-design-here/full_print_sweatshirt.png'
import full_print_tanktop from '../../assets/images/your-design-here/full_print_tanktop.png'
import full_print_tee from '../../assets/images/your-design-here/full_print_tee.png'
import full_print_waist_bag from '../../assets/images/your-design-here/full_print_waist_bag.png'
import full_print_woman_hoodie from '../../assets/images/your-design-here/full_print_woman_hoodie.png'
import full_print_woman_polo from '../../assets/images/your-design-here/full_print_woman_polo.png'
import full_print_woman_sweatshirt from '../../assets/images/your-design-here/full_print_woman_sweatshirt.png'
import full_print_woman_tanktop from '../../assets/images/your-design-here/full_print_woman_tanktop.png'
import full_print_woman_tee from '../../assets/images/your-design-here/full_print_woman_tee.png'
import galaxy_note_case from '../../assets/images/your-design-here/galaxy_note_case.png'
import galaxy_note2_case from '../../assets/images/your-design-here/galaxy_note2_case.png'
import galaxy_s2_case from '../../assets/images/your-design-here/galaxy_s2_case.png'
import galaxy_s3_case from '../../assets/images/your-design-here/galaxy_s3_case.png'
import galaxy_s4_case from '../../assets/images/your-design-here/galaxy_s4_case.png'
import galaxy_s5_case from '../../assets/images/your-design-here/galaxy_s5_case.png'
import galaxy_s6_case from '../../assets/images/your-design-here/galaxy_s6_case.png'
import galaxy_s6_edge_case from '../../assets/images/your-design-here/galaxy_s6_edge_case.png'
import galaxy_s7_case from '../../assets/images/your-design-here/galaxy_s7_case.png'
import galaxy_s7_edge_case from '../../assets/images/your-design-here/galaxy_s7_edge_case.png'
import galaxy_s7_edge_leather_case from '../../assets/images/your-design-here/galaxy_s7_edge_leather_case.png'
import galaxy_s7_edge_silicone_case from '../../assets/images/your-design-here/galaxy_s7_edge_silicone_case.png'
import galaxy_s7_leather_case from '../../assets/images/your-design-here/galaxy_s7_leather_case.png'
import galaxy_s7_silicone_case from '../../assets/images/your-design-here/galaxy_s7_silicone_case.png'
import galaxy_s8_case from '../../assets/images/your-design-here/galaxy_s8_case.png'
import galaxy_s8_leather_case from '../../assets/images/your-design-here/galaxy_s8_leather_case.png'
import galaxy_s8_plus_case from '../../assets/images/your-design-here/galaxy_s8_plus_case.png'
import galaxy_s8_plus_leather_case from '../../assets/images/your-design-here/galaxy_s8_plus_leather_case.png'
import galaxy_s8_plus_silicone_case from '../../assets/images/your-design-here/galaxy_s8_plus_silicone_case.png'
import galaxy_s8_silicone_case from '../../assets/images/your-design-here/galaxy_s8_silicone_case.png'
import gift_bag8x12 from '../../assets/images/your-design-here/gift_bag8x12.png'
import gift_bag15x22 from '../../assets/images/your-design-here/gift_bag15x22.png'
import gift_bag20x30 from '../../assets/images/your-design-here/gift_bag20x30.png'
import gift_box330x230x100 from '../../assets/images/your-design-here/gift_box330x230x100.png'
import hat from '../../assets/images/your-design-here/hat.png'
import heart_magnet75x97 from '../../assets/images/your-design-here/heart_magnet75x97.png'
import heart_mouse_pad from '../../assets/images/your-design-here/heart_mouse_pad.png'
import heart_sticker50x65 from '../../assets/images/your-design-here/heart_sticker50x65.png'
import heart_sticker75x97 from '../../assets/images/your-design-here/heart_sticker75x97.png'
import hockey_uniform from '../../assets/images/your-design-here/hockey_uniform.png'
import hoodie from '../../assets/images/your-design-here/hoodie.png'
import iphone_x_case from '../../assets/images/your-design-here/iphone_x_case.png'
import iphone11_case from '../../assets/images/your-design-here/iphone11_case.png'
import iphone11_pro_case from '../../assets/images/your-design-here/iphone11_pro_case.png'
import iphone11_pro_max_case from '../../assets/images/your-design-here/iphone11_pro_max_case.png'
import iphone12_case from '../../assets/images/your-design-here/iphone12_case.png'
import iphone12_mini_case from '../../assets/images/your-design-here/iphone12_mini_case.png'
import iphone12_pro_case from '../../assets/images/your-design-here/iphone12_pro_case.png'
import iphone13_case from '../../assets/images/your-design-here/iphone13_case.png'
import iphone13_pro_case from '../../assets/images/your-design-here/iphone13_pro_case.png'
import iphone13_pro_max_case from '../../assets/images/your-design-here/iphone13_pro_max_case.png'
import iphone14_case from '../../assets/images/your-design-here/iphone14_case.png'
import iphone14_pro_case from '../../assets/images/your-design-here/iphone14_pro_case.png'
import iphone14_pro_max_case from '../../assets/images/your-design-here/iphone14_pro_max_case.png'
import iphone4_case from '../../assets/images/your-design-here/iphone4_case.png'
import iphone4_glossy_case from '../../assets/images/your-design-here/iphone4_glossy_case.png'
import iphone5_case from '../../assets/images/your-design-here/iphone5_case.png'
import iphone5_glossy_case from '../../assets/images/your-design-here/iphone5_glossy_case.png'
import iphone5_kickstand_case from '../../assets/images/your-design-here/iphone5_kickstand_case.png'
import iphone5_volumetric_case from '../../assets/images/your-design-here/iphone5_volumetric_case.png'
import iphone6_case from '../../assets/images/your-design-here/iphone6_case.png'
import iphone6_plus_case from '../../assets/images/your-design-here/iphone6_plus_case.png'
import iphone6_plus_glossy_case from '../../assets/images/your-design-here/iphone6_plus_glossy_case.png'
import iphone6_volumetric_case from '../../assets/images/your-design-here/iphone6_volumetric_case.png'
import iphone7_case from '../../assets/images/your-design-here/iphone7_case.png'
import iphone7_glossy_case from '../../assets/images/your-design-here/iphone7_glossy_case.png'
import iphone7_plus_case from '../../assets/images/your-design-here/iphone7_plus_case.png'
import iphone7_plus_glossy_case from '../../assets/images/your-design-here/iphone7_plus_glossy_case.png'
import iphone8_case from '../../assets/images/your-design-here/iphone8_case.png'
import iphone8_plus_case from '../../assets/images/your-design-here/iphone8_plus_case.png'
import kids_football_uniform from '../../assets/images/your-design-here/kids_football_uniform.png'
import kids_hoodie from '../../assets/images/your-design-here/kids_hoodie.png'
import kids_panama from '../../assets/images/your-design-here/kids_panama.png'
import kids_sport_tee from '../../assets/images/your-design-here/kids_sport_tee.png'
import kids_sweatshirt from '../../assets/images/your-design-here/kids_sweatshirt.png'
import kids_tee from '../../assets/images/your-design-here/kids_tee.png'
import kids_zip_hoodie from '../../assets/images/your-design-here/kids_zip_hoodie.png'
import kitchen_scale from '../../assets/images/your-design-here/kitchen_scale.png'
import knitted_hat from '../../assets/images/your-design-here/knitted_hat.png'
import laptop_sleeve12 from '../../assets/images/your-design-here/laptop_sleeve12.png'
import laptop_sleeve14 from '../../assets/images/your-design-here/laptop_sleeve14.png'
import large_classic_tee from '../../assets/images/your-design-here/large_classic_tee.png'
import large_envelope from '../../assets/images/your-design-here/large_envelope.png'
import large_full_print_tee from '../../assets/images/your-design-here/large_full_print_tee.png'
import large_pencil_case from '../../assets/images/your-design-here/large_pencil_case.png'
import leggings from '../../assets/images/your-design-here/leggings.png'
import leather_passport_cover from '../../assets/images/your-design-here/leather_passport_cover.png'
import lighter from '../../assets/images/your-design-here/lighter.png'
import light_hoodie from '../../assets/images/your-design-here/light_hoodie.png'
import long_sleeve_dress from '../../assets/images/your-design-here/long_sleeve_dress.png'
import long_socks from '../../assets/images/your-design-here/long_socks.png'
import longsleeve from '../../assets/images/your-design-here/longsleeve.png'
import man_bomber from '../../assets/images/your-design-here/man_bomber.png'
import man_pajama_pants from '../../assets/images/your-design-here/man_pajama_pants.png'
import man_pants from '../../assets/images/your-design-here/man_pants.png'
import man_sneakers from '../../assets/images/your-design-here/man_sneakers.png'
import man_stretch_tee from '../../assets/images/your-design-here/man_stretch_tee.png'
import man_suspenders from '../../assets/images/your-design-here/man_suspenders.png'
import man_underpants from '../../assets/images/your-design-here/man_underpants.png'
import mask from '../../assets/images/your-design-here/mask.png'
import mask_scarf from '../../assets/images/your-design-here/mask_scarf.png'
import masquerade_balaclava from '../../assets/images/your-design-here/masquerade_balaclava.png'
import maternity_tee from '../../assets/images/your-design-here/maternity_tee.png'
import medium_envelope from '../../assets/images/your-design-here/medium_envelope.png'
import metal_bottle from '../../assets/images/your-design-here/metal_bottle.png'
import moneybox from '../../assets/images/your-design-here/moneybox.png'
import mouse_pad from '../../assets/images/your-design-here/mouse_pad.png'
import mug from '../../assets/images/your-design-here/mug.png'
import nametag from '../../assets/images/your-design-here/nametag.png'
import notebook_glued from '../../assets/images/your-design-here/notebook_glued.png'
import notebook_spring from '../../assets/images/your-design-here/notebook_spring.png'
import notebook_stapled from '../../assets/images/your-design-here/notebook_stapled.png'
import notepad_a4 from '../../assets/images/your-design-here/notepad_a4.png'
import notepad from '../../assets/images/your-design-here/notepad.png'
import oval_sticker98x70 from '../../assets/images/your-design-here/oval_sticker98x70.png'
import oval_sticker150x90 from '../../assets/images/your-design-here/oval_sticker150x90.png'
import oversize_hoodie from '../../assets/images/your-design-here/oversize_hoodie.png'
import oversize_tee from '../../assets/images/your-design-here/oversize_tee.png'
import oversize_pocket_tee from '../../assets/images/your-design-here/oversize_pocket_tee.png'
import package155x220x50 from '../../assets/images/your-design-here/package155x220x50.png'
import package220x155x50 from '../../assets/images/your-design-here/package220x155x50.png'
import package250x350x80 from '../../assets/images/your-design-here/package250x350x80.png'
import paired_tee from '../../assets/images/your-design-here/paired_tee.png'
import paired_wineglass from '../../assets/images/your-design-here/paired_wineglass.png'
import panama from '../../assets/images/your-design-here/panama.png'
import passport_cover from '../../assets/images/your-design-here/passport_cover.png'
import pen from '../../assets/images/your-design-here/pen.png'
import pencil from '../../assets/images/your-design-here/pencil.png'
import phone_cardholder from '../../assets/images/your-design-here/phone_cardholder.png'
import photo_tile from '../../assets/images/your-design-here/photo_tile.png'
import pillow from '../../assets/images/your-design-here/pillow.png'
import pillow40x40 from '../../assets/images/your-design-here/pillow40x40.png'
import pillow60x40 from '../../assets/images/your-design-here/pillow60x40.png'
import pillow150x50 from '../../assets/images/your-design-here/pillow150x50.png'
import plaid_fleece130x170 from '../../assets/images/your-design-here/plaid_fleece130x170.png'
import planner from '../../assets/images/your-design-here/planner.png'
import plastic_bottle from '../../assets/images/your-design-here/plastic_bottle.png'
import plastic_pen from '../../assets/images/your-design-here/plastic_pen.png'
import plate from '../../assets/images/your-design-here/plate.png'
import playing_card from '../../assets/images/your-design-here/playing_card.png'
import pleated_skirt from '../../assets/images/your-design-here/pleated_skirt.png'
import polo_shirt from '../../assets/images/your-design-here/polo_shirt.png'
import postcard from '../../assets/images/your-design-here/postcard.png'
import postcard15x10 from '../../assets/images/your-design-here/postcard15x10.png'
import postcard21x10 from '../../assets/images/your-design-here/postcard21x10.png'
import poster_a2 from '../../assets/images/your-design-here/poster_a2.png'
import poster from '../../assets/images/your-design-here/poster.png'
import powerbank from '../../assets/images/your-design-here/powerbank.png'
import puzzle_a3 from '../../assets/images/your-design-here/puzzle_a3.png'
import puzzle_a4 from '../../assets/images/your-design-here/puzzle_a4.png'
import puzzle_photo_frame from '../../assets/images/your-design-here/puzzle_photo_frame.png'
import puzzle408 from '../../assets/images/your-design-here/puzzle408.png'
import puzzle1000 from '../../assets/images/your-design-here/puzzle1000.png'
import raincoat from '../../assets/images/your-design-here/raincoat.png'
import rashguard from '../../assets/images/your-design-here/rashguard.png'
import rectangle_keychain35x25 from '../../assets/images/your-design-here/rectangle_keychain35x25.png'
import rectangle_keychain50x35 from '../../assets/images/your-design-here/rectangle_keychain50x35.png'
import rectangle_magnet90x50 from '../../assets/images/your-design-here/rectangle_magnet90x50.png'
import rectangle_magnet150x45 from '../../assets/images/your-design-here/rectangle_magnet150x45.png'
import rectangle_sticker90x50 from '../../assets/images/your-design-here/rectangle_sticker90x50.png'
import rectangle_sticker150x45 from '../../assets/images/your-design-here/rectangle_sticker150x45.png'
import removka from '../../assets/images/your-design-here/removka.png'
import ringer_man_tee from '../../assets/images/your-design-here/ringer_man_tee.png'
import ringer_woman_tee from '../../assets/images/your-design-here/ringer_woman_tee.png'
import rolled_rectangle_sticker105x74 from '../../assets/images/your-design-here/rolled_rectangle_sticker105x74.png'
import rolled_rectangle_sticker74x52 from '../../assets/images/your-design-here/rolled_rectangle_sticker74x52.png'
import rolled_round_sticker50 from '../../assets/images/your-design-here/rolled_round_sticker50.png'
import rolled_square_sticker50x50 from '../../assets/images/your-design-here/rolled_square_sticker50x50.png'
import round_magnet50x50 from '../../assets/images/your-design-here/round_magnet50x50.png'
import round_mouse_pad from '../../assets/images/your-design-here/round_mouse_pad.png'
import round_plastic_clock from '../../assets/images/your-design-here/round_plastic_clock.png'
import round_plate from '../../assets/images/your-design-here/round_plate.png'
import round_sticker50x50 from '../../assets/images/your-design-here/round_sticker50x50.png'
import round_sticker95x95 from '../../assets/images/your-design-here/round_sticker95x95.png'
import round_wood_clock from '../../assets/images/your-design-here/round_wood_clock.png'
import shopping_bag from '../../assets/images/your-design-here/shopping_bag.png'
import short_socks from '../../assets/images/your-design-here/short_socks.png'
import shot from '../../assets/images/your-design-here/shot.png'
import shower_curtain from '../../assets/images/your-design-here/shower_curtain.png'
import sleep_mask from '../../assets/images/your-design-here/sleep_mask.png'
import sleeveless_dress from '../../assets/images/your-design-here/sleeveless_dress.png'
import small_envelope from '../../assets/images/your-design-here/small_envelope.png'
import small_pencil_case from '../../assets/images/your-design-here/small_pencil_case.png'
import snapback from '../../assets/images/your-design-here/snapback.png'
import sport_bottle from '../../assets/images/your-design-here/sport_bottle.png'
import speaker from '../../assets/images/your-design-here/speaker.png'
import square_keychain from '../../assets/images/your-design-here/square_keychain.png'
import square_magnet50x50 from '../../assets/images/your-design-here/square_magnet50x50.png'
import square_magnet95x95 from '../../assets/images/your-design-here/square_magnet95x95.png'
import square_pillow from '../../assets/images/your-design-here/square_pillow.png'
import square_sticker50x50 from '../../assets/images/your-design-here/square_sticker50x50.png'
import square_sticker95x95 from '../../assets/images/your-design-here/square_sticker95x95.png'
import square_tablecloth from '../../assets/images/your-design-here/square_tablecloth.png'
import square_wood_clock from '../../assets/images/your-design-here/square_wood_clock.png'
import standard_pen from '../../assets/images/your-design-here/standard_pen.png'
import star_magnet75x75 from '../../assets/images/your-design-here/star_magnet75x75.png'
import star_sticker75x75 from '../../assets/images/your-design-here/star_sticker75x75.png'
import star_sticker145x145 from '../../assets/images/your-design-here/star_sticker145x145.png'
import stone_photo_frame from '../../assets/images/your-design-here/stone_photo_frame.png'
import stretch_tee from '../../assets/images/your-design-here/stretch_tee.png'
import suction_thermo_mug from '../../assets/images/your-design-here/suction_thermo_mug.png'
import sweatshirt from '../../assets/images/your-design-here/sweatshirt.png'
import tanktop from '../../assets/images/your-design-here/tanktop.png'
import tapestry180x145 from '../../assets/images/your-design-here/tapestry180x145.png'
import tee from '../../assets/images/your-design-here/tee.png'
import thermos from '../../assets/images/your-design-here/thermos.png'
import thermosticker from '../../assets/images/your-design-here/thermosticker.png'
import thermo_mug from '../../assets/images/your-design-here/thermo_mug.png'
import toothbrush from '../../assets/images/your-design-here/toothbrush.png'
import towel30x30 from '../../assets/images/your-design-here/towel30x30.png'
import towel35x75 from '../../assets/images/your-design-here/towel35x75.png'
import towel50x90 from '../../assets/images/your-design-here/towel50x90.png'
import umbrella_bilateral from '../../assets/images/your-design-here/umbrella_bilateral.png'
import umbrella_unilateral from '../../assets/images/your-design-here/umbrella_unilateral.png'
import universal_hoodie from '../../assets/images/your-design-here/universal_hoodie.png'
import universal_product from '../../assets/images/your-design-here/universal_product.png'
import windbreaker from '../../assets/images/your-design-here/windbreaker.png'
import wineglass from '../../assets/images/your-design-here/wineglass.png'
import woman_bomber from '../../assets/images/your-design-here/woman_bomber.png'
import woman_hoodie from '../../assets/images/your-design-here/woman_hoodie.png'
import woman_pajama_pants from '../../assets/images/your-design-here/woman_pajama_pants.png'
import woman_pants from '../../assets/images/your-design-here/woman_pants.png'
import woman_polo from '../../assets/images/your-design-here/woman_polo.png'
import woman_sneakers from '../../assets/images/your-design-here/woman_sneakers.png'
import woman_suspenders from '../../assets/images/your-design-here/woman_suspenders.png'
import woman_tanktop from '../../assets/images/your-design-here/woman_tanktop.png'
import woman_tee from '../../assets/images/your-design-here/woman_tee.png'
import woman_underpants from '../../assets/images/your-design-here/woman_underpants.png'
import women_cotton_sweatshirt from '../../assets/images/your-design-here/women_cotton_sweatshirt.png'

export default {
    apron,
    backpack,
    badge,
    bag,
    bandana,
    basic_hoodie,
    basketball_uniform,
    beanie,
    beer_mug,
    bib,
    blackberry_z10_case,
    bodysuit,
    bottle_sticker,
    buff,
    business_card,
    cake,
    calendar_a2,
    calendar_a3,
    calendar_single_a2,
    can,
    candle,
    canvas20x30,
    canvas30x30,
    canvas30x40,
    canvas30x60,
    canvas40x55,
    canvas50x50,
    canvas50x75,
    canvas60x90,
    cap_trucker,
    cardboard_tag,
    cardholder,
    chocolate,
    chocolate_set_shell,
    chocolate_set_souffle,
    chocolate_set4,
    chocolate_set12,
    chocolate_set16,
    chocolate35x35,
    christmas_ball,
    christmas_tree_toy,
    city_backpack,
    classic_polo_shirt,
    classic_tee,
    classic_woman_polo,
    classic_woman_tee,
    colored_handle_mug,
    colored_hood_and_sleeves_hoodie,
    colored_inside_mug,
    colored_pocket_hoodie,
    cotton_backpack,
    crop_tee,
    cube,
    cutting_board,
    cycling_shorts,
    dog_tee,
    earflap_hat,
    euro_business_card,
    flag22x15,
    flag135x90,
    flag150x100,
    flash_driver,
    football_uniform,
    free_form_sticker,
    full_print_apron,
    full_print_backpack,
    full_print_bag,
    full_print_beanie,
    full_print_boy_tee,
    full_print_cosmetic_bag,
    full_print_gloves,
    full_print_girl_tee,
    full_print_hoodie,
    full_print_kids_sweatshirt,
    full_print_man_polo,
    full_print_mittens,
    full_print_mug,
    full_print_neck_pillow,
    full_print_pencil_case,
    full_print_pencil_skirt,
    full_print_skirt,
    full_print_sport_tee,
    full_print_summer_dress,
    full_print_sweatshirt,
    full_print_tanktop,
    full_print_tee,
    full_print_waist_bag,
    full_print_woman_hoodie,
    full_print_woman_polo,
    full_print_woman_sweatshirt,
    full_print_woman_tanktop,
    full_print_woman_tee,
    galaxy_note_case,
    galaxy_note2_case,
    galaxy_s2_case,
    galaxy_s3_case,
    galaxy_s4_case,
    galaxy_s5_case,
    galaxy_s6_case,
    galaxy_s6_edge_case,
    galaxy_s7_case,
    galaxy_s7_edge_case,
    galaxy_s7_edge_leather_case,
    galaxy_s7_edge_silicone_case,
    galaxy_s7_leather_case,
    galaxy_s7_silicone_case,
    galaxy_s8_case,
    galaxy_s8_leather_case,
    galaxy_s8_plus_case,
    galaxy_s8_plus_leather_case,
    galaxy_s8_plus_silicone_case,
    galaxy_s8_silicone_case,
    gift_bag8x12,
    gift_bag15x22,
    gift_bag20x30,
    gift_box330x230x100,
    hat,
    heart_magnet75x97,
    heart_mouse_pad,
    heart_sticker50x65,
    heart_sticker75x97,
    hockey_uniform,
    hoodie,
    iphone_x_case,
    iphone11_case,
    iphone11_pro_case,
    iphone11_pro_max_case,
    iphone12_case,
    iphone12_mini_case,
    iphone12_pro_case,
    iphone13_case,
    iphone13_pro_case,
    iphone13_pro_max_case,
    iphone14_case,
    iphone14_pro_case,
    iphone14_pro_max_case,
    iphone4_case,
    iphone4_glossy_case,
    iphone5_case,
    iphone5_glossy_case,
    iphone5_kickstand_case,
    iphone5_volumetric_case,
    iphone6_case,
    iphone6_plus_case,
    iphone6_plus_glossy_case,
    iphone6_volumetric_case,
    iphone7_case,
    iphone7_glossy_case,
    iphone7_plus_case,
    iphone7_plus_glossy_case,
    iphone8_case,
    iphone8_plus_case,
    kids_football_uniform,
    kids_hoodie,
    kids_panama,
    kids_sweatshirt,
    kids_sport_tee,
    kids_tee,
    kids_zip_hoodie,
    kitchen_scale,
    knitted_hat,
    laptop_sleeve12,
    laptop_sleeve14,
    large_classic_tee,
    large_envelope,
    large_full_print_tee,
    large_pencil_case,
    leather_passport_cover,
    leggings,
    lighter,
    light_hoodie,
    long_socks,
    long_sleeve_dress,
    longsleeve,
    man_bomber,
    man_pants,
    man_pajama_pants,
    man_sneakers,
    man_stretch_tee,
    man_suspenders,
    man_underpants,
    mask,
    mask_scarf,
    masquerade_balaclava,
    maternity_tee,
    medium_envelope,
    metal_bottle,
    moneybox,
    mouse_pad,
    mug,
    nametag,
    notebook_glued,
    notebook_spring,
    notebook_stapled,
    notepad_a4,
    notepad,
    oval_sticker98x70,
    oval_sticker150x90,
    oversize_hoodie,
    oversize_tee,
    oversize_pocket_tee,
    package155x220x50,
    package220x155x50,
    package250x350x80,
    paired_tee,
    paired_wineglass,
    panama,
    passport_cover,
    pen,
    pencil,
    phone_cardholder,
    photo_tile,
    pillow,
    pillow40x40,
    pillow60x40,
    pillow150x50,
    plaid_fleece130x170,
    planner,
    plastic_bottle,
    plastic_pen,
    plate,
    playing_card,
    pleated_skirt,
    polo_shirt,
    postcard,
    postcard15x10,
    postcard21x10,
    poster_a2,
    poster,
    powerbank,
    puzzle_a3,
    puzzle_a4,
    puzzle_photo_frame,
    puzzle408,
    puzzle1000,
    raincoat,
    rashguard,
    rectangle_keychain35x25,
    rectangle_keychain50x35,
    rectangle_magnet90x50,
    rectangle_magnet150x45,
    rectangle_sticker90x50,
    rectangle_sticker150x45,
    removka,
    ringer_man_tee,
    ringer_woman_tee,
    rolled_rectangle_sticker105x74,
    rolled_rectangle_sticker74x52,
    rolled_round_sticker50,
    rolled_square_sticker50x50,
    round_magnet50x50,
    round_mouse_pad,
    round_plastic_clock,
    round_plate,
    round_sticker50x50,
    round_sticker95x95,
    round_wood_clock,
    shopping_bag,
    short_socks,
    shot,
    shower_curtain,
    sleep_mask,
    sleeveless_dress,
    small_envelope,
    small_pencil_case,
    snapback,
    speaker,
    sport_bottle,
    square_keychain,
    square_magnet50x50,
    square_magnet95x95,
    square_pillow,
    square_sticker50x50,
    square_sticker95x95,
    square_tablecloth,
    square_wood_clock,
    standard_pen,
    star_magnet75x75,
    star_sticker75x75,
    star_sticker145x145,
    stone_photo_frame,
    stretch_tee,
    suction_thermo_mug,
    sweatshirt,
    tanktop,
    tapestry180x145,
    tee,
    thermos,
    thermosticker,
    thermo_mug,
    toothbrush,
    towel30x30,
    towel35x75,
    towel50x90,
    umbrella_bilateral,
    umbrella_unilateral,
    universal_hoodie,
    universal_product,
    windbreaker,
    wineglass,
    woman_bomber,
    woman_hoodie,
    woman_pajama_pants,
    woman_pants,
    woman_polo,
    woman_sneakers,
    woman_suspenders,
    woman_tanktop,
    woman_tee,
    woman_underpants,
    women_cotton_sweatshirt,
}
